import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ConversationView from '../conversation/ConversationView.vue';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const meta = {
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/monitor'),
    name: 'monitor_dashboard',
    meta,
    component: ConversationView,
    props: () => ({
      inboxId: 0,
      initialStatus: 'all',
      readOnly: true,
      monitorMode: true,
      pageTitleOverride: 'Monitor',
    }),
  },
  {
    path: frontendURL('accounts/:accountId/monitor/conversations/:conversation_id'),
    name: 'monitor_conversation',
    meta,
    component: ConversationView,
    props: route => ({
      conversationId: route.params.conversation_id,
      inboxId: 0,
      initialStatus: 'all',
      readOnly: true,
      monitorMode: true,
      pageTitleOverride: 'Monitor',
    }),
  },
];
